import { Routes } from '@angular/router';
import { UiTemplateComponent } from '@core';
import { Environment, Role } from '@domains';
import { AuthGuard, OnboardingGuard, RoleGuard } from '@rspl-auth';
import { HealthCheckComponent } from '@rspl-ui';

export const appRoutes = (environment: Environment) =>
  [
    {
      path: '',
      component: UiTemplateComponent,
      children: [
        {
          path: '',
          canActivate: [AuthGuard, OnboardingGuard, RoleGuard],
          data: { roles: [Role.PARTNER] },
          loadChildren: () => import('@donations').then((module) => module.donationsRoutes(environment)),
        },
        {
          path: 'trucks',
          canActivate: [AuthGuard, OnboardingGuard, RoleGuard],
          data: { roles: [Role.PARTNER] },
          loadChildren: () => import('@trucks').then((module) => module.trucksRoutes(environment)),
        },
        {
          path: 'onboarding',
          loadChildren: () => import('@onboarding').then((module) => module.onboardingRoutes(environment)),
        },
        {
          path: 'users',
          canActivate: [AuthGuard, OnboardingGuard, RoleGuard],
          data: { roles: [Role.PARTNER] },
          loadChildren: () => import('@users').then((module) => module.usersRoutes(environment)),
        },
        {
          path: 'settings',
          canActivate: [AuthGuard, OnboardingGuard, RoleGuard],
          data: { roles: [Role.PARTNER] },
          loadChildren: () => import('@partners').then((module) => module.partnersRoutes(environment)),
        },
        {
          path: 'journeys',
          loadChildren: () => import('@journeys').then((module) => module.journeysRoutes(environment)),
        },
      ],
    },
    {
      path: 'hc',
      component: HealthCheckComponent,
    },
    {
      path: '**',
      redirectTo: '/',
    },
  ] as Routes;
